var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var ui_extensions = require("ui-extensions");
var cio_datamodel = require("cio-datamodel");

var PathSegmentModel = function (pathInteractionModel, object, next_handle, prev_handle) {
    var self = this;

    this.makeObservableTreeNode();

    this.pathInteractionModel = pathInteractionModel;
    this.object = object;

    this.next_handle = next_handle;
    this.prev_handle = prev_handle;
    this.next_handle.prev_segment = this;
    this.prev_handle.next_segment = this;

    this.infocus = this.value("infocus", false);

    this.infocus.onChange('handle_highlight', function(val) {
        self.prev_handle.highlighted(val);
        self.next_handle.highlighted(val);
    });

    this.onInit("onInit", this.initialize, 10);
};
lib_core.mixin(PathSegmentModel, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(PathSegmentModel, "PathSegmentModel");

module.exports = PathSegmentModel;

PathSegmentModel.prototype.initialize = function() {
    var self = this;

    this.showMode = this.shadow("showMode",
        function () {
            return self.object.type();
        },
        function (value) {
            //value will be a string (DOM value), but mode is an integer
            return self.convertToMode(parseInt(value));
        },
        [] //this.object.type //not required since pathsegmentmodel is rebuilt when type changes
    );
};

PathSegmentModel.prototype.getInspectorElements = function() {
    var inspectorElements = {input_elements:[]};

    inspectorElements.input_elements.push(
        {
            label       : 'Segment Type',
            type        : ui_extensions.InspectorInputType.SELECTBOX,
            datamember  : this.showMode,
            list        : [["Line", 1], ["Bezier", 2], ["Arc", 4]]

        });

    return inspectorElements;
};

PathSegmentModel.prototype.beforeMoveStartPoint = function(vec) {
};

PathSegmentModel.prototype.beforeMoveEndPoint = function(vec) {
};

PathSegmentModel.prototype.afterMoveStartPoint = function(vec) {
};

PathSegmentModel.prototype.afterMoveEndPoint = function(vec) {
};

PathSegmentModel.prototype.getSubSnapSet = function (result) {
};

PathSegmentModel.prototype.setSelectedSubElement = function(val) {
    this.infocus(val);
};

PathSegmentModel.prototype.convertToMode = function (new_mode) {
    var self = this;
    var prev = self.prev_handle;
    var next = self.next_handle;

    switch (new_mode) {
        case cio_datamodel.PathType.CURVEC:
            var seg = new lib_geometry.Segment(prev.coord(), next.coord());
            self.object.tan_0(seg.getPoint(1/4));
            self.object.tan_1(seg.getPoint(3/4));

            //TODO:
            // if (prev) {
            //     if (prev.mode() == cio_datamodel.PathPointMode.STRAIGHT) {
            //         prev.tan_1().coord(prev.coord());
            //     }
            // }

            // if (next) {
            //     if (next.mode() == cio_datamodel.PathPointMode.STRAIGHT) {
            //         next.tan_0().coord(next.coord());
            //     }
            // }

            // var tan;
            // if (next && prev) {
            //     tan = next.coord().sub(prev.coord()).mult(0.3);
            //     self.tan_0().coord(self.coord().sub(tan));
            //     self.tan_1().coord(self.coord().add(tan));
            // } else if (next) {
            //     tan = next.coord().sub(self.coord()).mult(0.3);
            //     self.tan_1().coord(self.coord().add(tan));
            // } else if (prev) {
            //     tan = self.coord().sub(prev.coord()).mult(0.3);
            //     self.tan_0().coord(self.coord().sub(tan));
            // } else {
            //     console.log("Trouble");
            // }
            self.object.type(cio_datamodel.PathType.CURVEC);

            break;
        case cio_datamodel.PathType.LINE:
            self.object.tan_0(prev.coord());
            self.object.tan_1(next.coord());

            self.object.type(cio_datamodel.PathType.LINE);
            break;

        case cio_datamodel.PathType.ARC:
            self.object.sweepFlag(true);
            self.object.angle(0);

            var r = next.coord().distance(prev.coord()) / 2;
            self.object.xRadius(r);
            self.object.yRadius(r);

            self.object.type(cio_datamodel.PathType.ARC);
            break;
        default:
            throw new Error();
    }
};

PathSegmentModel.prototype.createPathObjectOnSegment = function(coord) {
    return new cio_datamodel.PathObjectData(coord.copy(), cio_datamodel.PathType.LINE);
};
